import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { HeartHandshake } from "lucide-react";

const WeddingEntry = () => {
  const serviceData = {
    serviceName: "Wedding Entry & Photoshoot",
    heroImage: require("../../assets/wedding_highkraft.jpeg"),
    heroTagline: "Grand Entrances, Eternal Memories",
    heroDescription:
      "Make your wedding day truly unforgettable with a spectacular helicopter entrance. Create stunning aerial photographs that will be cherished for a lifetime.",
    overviewTitle: "Helicopter Wedding Entry & Photography Services",
    overviewText: `HighKraft Aviation transforms dream weddings into reality with our exclusive helicopter wedding entry and aerial photoshoot services. Make a grand entrance that will leave your guests speechless and create photographs that capture the magic of your special day from breathtaking angles.

Imagine descending from the sky as the bride or groom, making an entrance that sets the tone for an extraordinary celebration. Our wedding helicopter service isn't just about transport – it's about creating a moment that you and your guests will remember forever.

Beyond the dramatic entrance, our aerial photography service captures your wedding venue, the couple, and the celebrations from unique perspectives impossible to achieve from the ground. Professional coordination ensures the helicopter photoshoot integrates seamlessly with your wedding photography timeline.`,
    useCases: [
      {
        title: "Groom Entry",
        description:
          "Make a royal arrival with a helicopter landing that sets the grand tone for the baraat.",
      },
      {
        title: "Bride Entry",
        description:
          "A princess-like arrival for the bride, creating a fairy-tale moment.",
      },
      {
        title: "Couple Photoshoot",
        description:
          "Stunning aerial photographs of the couple with the venue as backdrop.",
      },
      {
        title: "Venue Photography",
        description:
          "Breathtaking aerial shots of the decorated wedding venue.",
      },
      {
        title: "Reception Entry",
        description:
          "Grand entry at the reception venue to wow your guests again.",
      },
      {
        title: "Pre-Wedding Shoots",
        description:
          "Unique pre-wedding photoshoots featuring helicopter and aerial views.",
      },
    ],
    safetyFeatures: [
      {
        title: "Venue Assessment",
        description:
          "Thorough pre-event survey of landing zones and safety clearances.",
      },
      {
        title: "Crowd Management",
        description:
          "Coordination with event management for guest safety during landing.",
      },
      {
        title: "Experienced Wedding Pilots",
        description:
          "Pilots experienced in venue landings and event coordination.",
      },
      {
        title: "Backup Planning",
        description:
          "Alternative arrangements in case of weather or technical issues.",
      },
      {
        title: "Insurance Coverage",
        description: "Comprehensive event insurance for peace of mind.",
      },
      {
        title: "Professional Coordination",
        description:
          "Seamless coordination with wedding planners and photographers.",
      },
    ],
    galleryImages: [
      require("../../assets/wedding_gal1.jpeg"),
      require("../../assets/wedding_gal2.jpeg"),
      require("../../assets/wedding_gal3.jpeg"),
    ],
    faqs: [
      {
        question: "What space is needed for a helicopter landing?",
        answer:
          "We typically need a clear, flat area of approximately 30x30 meters. Our team will assess your venue and identify the best landing zone during the planning phase.",
      },
      {
        question: "Can the bride wear a lehenga inside the helicopter?",
        answer:
          "Absolutely! Our helicopters have spacious cabins that can accommodate traditional wedding attire. We also provide guidance on getting in and out gracefully.",
      },
      {
        question: "How do you coordinate with our wedding photographer?",
        answer:
          "We work directly with your photography team to plan angles, timing, and coordination. Many photographers join us for aerial shots as well.",
      },
      {
        question: "What if the weather is bad on our wedding day?",
        answer:
          "We monitor weather closely and will communicate any concerns in advance. In case of unfavorable conditions, we discuss alternatives including rescheduling or ground-based alternatives.",
      },
      {
        question: "Can guests take a short joy ride during the wedding?",
        answer:
          "Yes! We can arrange guest joy rides during the reception, adding another memorable element to your celebration. This is subject to venue and scheduling coordination.",
      },
    ],
    icon: HeartHandshake,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default WeddingEntry;
